module.exports = __webpack_public_path__ + "static/media/help_icon_homu.9244c10f.png";